import React, { useContext } from 'react';
import { IoNotifications } from 'react-icons/io5';
import { Link } from 'react-router-dom';
import { AppContext } from '../../appContext';
import { CgProfile } from "react-icons/cg";
import { Badge, IconButton } from '@mui/material';
import { FaUserCircle } from 'react-icons/fa';
import placeholderimg from '../../Assets/img/logos/place_profile.png';

function SearchHeader({ profileData,headerTxt }) {
  const { loggedInUser,chatCount } = useContext(AppContext);
  let badgeElm ;
  if(chatCount >0){
    badgeElm =<span className="p-1 inline-flex justify-center items-center min-w-[18px] h-[18px] rounded-full bg-accent text-white !font-semibold smallText absolute top-0 right-0">
      {chatCount}
    </span>;
  }else{
    badgeElm =<div className="w-2 h-2 bg-accent absolute top-1.5 right-2 rounded-full"></div>;
  }
  return (
    <div className="items-center py-6 px-6 bg-white hidden lg:flex xl:px-10 sticky top-0 z-[899] border-b border-gray-100 shadow-md">
      <div>
      <p className=" text-coalBlack headingText capitalize">
          {headerTxt}
       </p>
      </div>
      <div className="w-fit flex gap-4 items-center xl:gap-2 ms-auto">
        <Link to={'/notification'} className="relative">
          {/* <IoNotifications className="text-2xl text-inherit p-1.5 hover:bg-gray-50 rounded-full w-9 h-9 cursor-pointer" />
          {badgeElm} */}
          <IconButton aria-label="notification">
            <Badge badgeContent={chatCount} slotProps={{ badge: {className: ' bg-accent text-white !font-bold'}}}>
              <IoNotifications className='text-2xl text-inherit hover:bg-gray-50 rounded-full cursor-pointer'/>
            </Badge>
          </IconButton>
        </Link>
        {/* <HiMail className="text-2xl text-gray-400 p-1.5 hover:bg-gray-50 rounded-full w-9 h-9 cursor-pointer" /> */}
        
        <div className="flex items-center gap-2">
          <Link to={'/profile/details'} >
              {loggedInUser?.data?.hospitalProfile?.profilePic ? (
                <img
                  className="w-8 h-8 rounded-full object-cover"
                  src={`${process.env.REACT_APP_API_URL}/${loggedInUser?.data?.hospitalProfile?.profilePic}`}
                />
              ) : (
                // <div className="w-10 h-10  rounded-full bg-avatar" />
                <IconButton>
                   <FaUserCircle  className='text-2xl text-inherit hover:bg-gray-50 rounded-full cursor-pointer' />
                </IconButton>
              )}
          </Link>

          <p className="baseText text-navLink capitalize">
            {loggedInUser?.data?.userName} 
          </p>
        </div>
        
      </div>
    </div>
  );
}

export default SearchHeader;
